if (!customElements.get('td-compact-delivery')) {
  customElements.define('td-compact-delivery', class extends HTMLElement {
    connectedCallback() {
      this.states = JSON.parse(this.querySelector('[data-variant-delivery]').textContent);
      this.onVariant = (event) => {
        if (String(event.detail?.sectionId) !== this.dataset.section) return;
        // The theme starts an asynchronous variant request at this point.
        this.querySelectorAll('[data-mode]').forEach((line) => { line.hidden = true; });
      };
      this.onResolved = (event) => {
        if (String(event.detail?.sectionId) !== this.dataset.section) return;
        this.showVariant(event.detail.variant?.id);
      };
      document.addEventListener('product:variant-change', this.onVariant);
      document.addEventListener('td:variant-resolved', this.onResolved);
      this.showVariant(this.dataset.selected);
    }
    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this.onVariant);
      document.removeEventListener('td:variant-resolved', this.onResolved);
    }
    showVariant(id) {
      const mode = this.states[String(id)] || 'out';
      this.querySelectorAll('[data-mode]').forEach((line) => {
        line.hidden = line.dataset.mode !== mode;
      });
    }
  });
}
